import { useTranslation } from 'react-i18next'
import ConfirmationDialog from 'shared-module/components/confirmation/ConfirmationDialog'

const ScheduleConflictsDialog = ({ open, onConfirm, onClose }) => {
  const { t } = useTranslation()
  return (
    <ConfirmationDialog
      open={open}
      onConfirm={onConfirm}
      onCancel={onClose}
      onClose={onClose}
      title={t('app:schedule.popup.conflict.header')}
      text={t('app:schedule.popup.conflict.body')}
      confirmText={t('app:schedule.popup.conflict.ok')}
      cancelText={t('app:schedule.popup.conflict.cancel')}
    />
  )
}
export default ScheduleConflictsDialog
